export default "__VITE_ASSET__BeTeBTWO__"